module.exports = __webpack_public_path__ + "img/studying_tours.7583fadd.png";